export const resources = {
  MyCloud: '',
  EdgeExtensionsPageTitle: ''
};
